import ProgressBar from '@ramonak/react-progress-bar';
import theme from '../../styles/themes/default';
import { ConsultsPackageInProgress } from './style';

interface BatchProgressStatusBarProps {
  completed?: number;
  completedPercentage: number;
  total?: number;
  failed?: number;
  barOnly?: boolean;
}

export const BatchProgressStatusBar = ({
  completed = 0,
  completedPercentage,
  total = 0,
  failed = 0,
  barOnly = false,
}: BatchProgressStatusBarProps) => {
  return (
    <ConsultsPackageInProgress>
      <div className="progress-bar-container">
        <ProgressBar
          completed={completedPercentage}
          bgColor={theme.colors.blue.light}
          isLabelVisible={false}
        />
      </div>

      <div>
        {!barOnly ? (
          <>
            <span>
              {completed} de {total} consultado(s)
            </span>
            {failed > 0 && <span>{failed} falharam</span>}
          </>
        ) : (
          <span>&nbsp;</span>
        )}
      </div>
    </ConsultsPackageInProgress>
  );
};
